/* eslint-disable react/prop-types */
// Calendar.js
import React, { useEffect, useState } from 'react';
import Day from './Day';

const Calendar = ({ events, renderBodyItem, startDate, monday, tuesday, wednesday, thursday, friday, saturday, sunday }) => {

  // const [currentDate, setCurrentDate] = useState(new Date(startDate));
  const [currentWeekDates, setCurrentWeekDates] = useState([]);
  // const currentDate = new Date(startDate);
  // const currentDayOfWeek = currentDate.getDay();
  // const diff = currentDate.getDate() - currentDayOfWeek + (currentDayOfWeek === 0 ? -6 : 1); // Adjust for Sunday

  // const monday = new Date(currentDate.setDate(diff))
  // const daysToNextWeek = 7 - currentDayOfWeek + 1;
  // const nextWeekStartDate = new Date(currentDate);
  // nextWeekStartDate.setDate(currentDate.getDate() + daysToNextWeek);

  useEffect(() => {
    const currentDate = new Date(startDate);
    console.log('startDate', startDate);
    const newCurrentWeekDates = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(currentDate);
      date.setDate(currentDate.getDate() + i);
      newCurrentWeekDates.push({ date: date, data: i === 0 ? monday : i === 1 ? tuesday : i === 2 ? wednesday : i === 3 ? thursday : i === 4 ? friday : i === 5 ? saturday : i === 6 ? sunday : [] });
    }
    setCurrentWeekDates(newCurrentWeekDates);
  }, [startDate, monday, tuesday, wednesday, thursday, friday, saturday, sunday]);
  // const currentWeekDates = [];
  // for (let i = 0; i < 7; i++) {
  //   const date = new Date(currentDate);
  //   date.setDate(currentDate.getDate() + i);
  //   currentWeekDates.push(date);
  // }
  // ... (rest of your Calendar component code)
  console.log('currentWeekDates', currentWeekDates);
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '5px' }}>
      {currentWeekDates.map((item) => {
        const day = item.date.getDate(); // Get the day number
        const dayEvents = events.filter((event) => event.day === day);
        return <Day key={day} day={day} events={dayEvents} date={item.date} data={item.data} renderBodyItem={renderBodyItem} />;
      })}
    </div>
  );
};

export default Calendar;